module.exports = __webpack_public_path__ + "img/screen-404.ea5497c5.png";